'use client'

import { useTranslation } from '../../hooks/useTranslation';

export default function SuperiorCustomerService() {
  const { t } = useTranslation();
  return (
    <section className="relative min-h-screen w-full overflow-hidden bg-[var(--background)]" id="services">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-[var(--background)]"></div>
      
      {/* Main Content Container */}
      <div className="relative z-10 min-h-screen flex items-center">
        <div className="w-full flex flex-col lg:flex-row">
          {/* Left side - Car Image */}
          <div className="lg:ml-[120px] xl:ml-[120px] relative lg:flex-1 h-64 sm:h-80 md:h-96 lg:h-screen bg-[var(--background)]">
            <img
              src="/images/sup.jpg"
              alt="Superior Customer Service"
              className="w-full h-full object-cover px-10"
            />
          
          </div>
          
          {/* Right side - Text Content */}
          <div className="bg-[var(--background)] flex items-end justify-left p-6 sm:p-8 md:p-10 lg:pl-10 lg:pr-16 xl:pr-20 lg:flex-1 lg:mb-[80px]">
            <div className="max-w-lg w-full">
              <h2 className="banner-title">
                {t('service.title')}
              </h2>
              <p className="text-banner font-poppins font-light lg:pt-5">
                {t('service.desc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}